module.exports = __webpack_public_path__ + "static/media/barney.d5c2610d.jpg";